import React from "react";
import MapElements from "@/components/MapElements";
import CardSkeleton from "~components/card/children/CardSkeleton";

export default function ProductListLoading({count = 12} :{count?: number}) {
  return (
    <div className="md:container mx-auto grid grid-cols-2 md:grid-cols-4 md:gap-[20px]">
      <MapElements
        data={Array(count).fill(0)}
        render={(_, index) => <CardSkeleton key={index} />}
      />
    </div>
  );
}
